module.exports = __webpack_public_path__ + "img/img7.58981b15.png";